<script setup lang="ts">
import Icon from "@/components/Ui/Icon/Icon.vue";

interface Props {
  label?: string;
  labelIcon?: string;
  labelClass?: string;
  titleClass?: string;
}

const props = defineProps<Props>();
</script>

<template>
  <div :class="$style.root">
    <div
      v-if="props.label || props.labelIcon"
      :class="{
        [$style.root__label]: true,
        [props.labelClass]: props.labelClass,
      }"
    >
      <Icon :name="props.labelIcon" />
      {{ label }}
    </div>
    <div
      v-if="$slots.title"
      :class="props.titleClass"
    >
      <slot name="title" />
    </div>
    <slot />
  </div>
</template>

<style lang="scss" module>
.root {
  @apply flex flex-col items-center gap-8;

  &__label {
    @apply text-neutral-600 bg-neutral-100 text-[24px] flex items-center gap-[10px] w-fit rounded-full pl-3 pr-4 py-3 leading-[1.2];

    & svg {
      @apply w-7 h-7 min-w-[28px];
    }
  }

  & h1 {
    @apply mb-7;
  }
}
</style>
